module.exports = __webpack_public_path__ + "img/check.9842b503.svg";